import { useDispatch, useSelector } from "react-redux";
import {
    useLocation,
    useNavigate
} from "react-router-dom";
import { displayDateTime, getCardColorIdx, getConfig, getDistanceFromLatLonInKm, runAnalytic } from "../services/functions";
import {BASE_URL, LOGOUT_PATH, REGISTER_PATH, USER_MANAGEMENT_PATH } from "../utility/path";
import CustomImage from "./CustomImage";
import ListItem from "./ListItem";
import { locationSaveAction } from "../redux/slices/locationSlice";
import { useEffect, useState } from "react";
import logo from '../logo192.png';
import { showAlert } from "../redux/slices/alertSlice";
import axios from "axios";
import { spinner } from "../redux/slices/spinnerSlice";
import useImageCacheIndexedDb from "../services/useImageCacheIndexedDb";
import "../card.css"
import { isClickBlocked, isWithinClosingTime } from "../utility/timingUtils";

// const location = localStorage.getItem("location")
// ? JSON.parse(localStorage.getItem("location"))
// : {latitude:-1,longitude:-1};

const Card = ({ idx, user, openDetailsModal }) => {
    const authData = useSelector(state => state?.auth?.data);
    const location = useSelector(state => state?.location?.data || { latitude: -1, longitude: -1 });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const urllocation = useLocation();
    const { image, loading } = useImageCacheIndexedDb(user?.profilePhoto);

    const ratingByOthersData = user?.ratingByOthers || [];
    const ratingByOthersGroupByData = groupBy(ratingByOthersData, rating => rating.rating);

    const averageRating = (1 * ratingByOthersGroupByData?.get(1)?.length +
        2 * ratingByOthersGroupByData?.get(2)?.length +
        3 * ratingByOthersGroupByData?.get(3)?.length +
        4 * ratingByOthersGroupByData?.get(4)?.length +
        5 * ratingByOthersGroupByData?.get(5)?.length) / ratingByOthersData?.length || 0;

    const averageRatingRound = Math.round(averageRating * 10) / 10;
    const isUserManagementPath = urllocation?.pathname === USER_MANAGEMENT_PATH;
    const [message,setMessage] = useState();

    const blocked = isClickBlocked();
    const isUserAvailable = user?.startTime && user?.endTime && !isWithinClosingTime(user?.startTime, user?.endTime) ? false : true;

    function groupBy(list, keyGetter) {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return map;
    }

    const handleClick = input => e => {
        e.preventDefault();

        // Closing time check — block interaction
        // if (blocked) {
        //     // dispatch(showAlert({
        //     //     message: "Service unavailable. Please try again later.",
        //     //     success: "warning"
        //     // }));
        //     return;
        // }

        if(isUserManagementPath){
            console.log('return')
            return;
        }
        if(!authData?.isLoggedIn){
            //dispatch(showAlert({ message: "Please login to view details!!", success: "warning" }));
            //localStorage.setItem("redirect",`/details/${input}`);
            //return navigate(LOGOUT_PATH);
            openDetailsModal(input);
            return;
        }
        if (authData?.isLoggedIn) {
            //runAnalytic(user.id, authData, dispatch, 1, user.id, user?.category?.[0]?.id);
            openDetailsModal(input);
            return;
            //return navigate(input)
        }
        return navigate(REGISTER_PATH);
    }

    const handleClick_CheckDistance = () => {
        console.log('check distance')
        dispatch(locationSaveAction({}))
    }

    const handleClick_ApplyPromo = user => async e => {
        if(!user){
            return;
        }
        try {
            const config = getConfig();
            const resp  = await axios.post(
              `${BASE_URL}/api/payments/cpfa`,
              {user},
              config
            );
            //dispatch(showAlert({ message: resp?.data?.message, success: true }));
            setMessage(resp?.data?.message);
        }catch (error) {
            console.error("Error loading data:", error);
            setMessage(error?.response?.data?.message);
            //dispatch(showAlert({ message: error?.response?.data?.message, success: false }));
        }
    }

    const handleClick_Refresh = user => async e => {
        if(!user){
            return;
        }
        try {
            const config = getConfig();
            const resp  = await axios.post(
              `${BASE_URL}/api/payments/refresh`,
              {id:user},
              config
            );
            setMessage(resp?.data?.message);
            //dispatch(showAlert({ message: resp?.data?.message, success: true }));
        }catch (error) {
            console.error("Error loading data:", error);
            setMessage(error?.response?.data?.message);
            //dispatch(showAlert({ message: error?.response?.data?.message, success: false }));
        }
    }
    
    const [showTransition, setShowTransition] = useState(false);
    useEffect(() => {
        setShowTransition(true);

        return () => { setShowTransition(false) }
    }, []);

    useEffect(() => {

    },[message]);

    return (
        <>
            {/* non-admin */}
            {user && !isUserManagementPath && (<div className={`card_ct card-${getCardColorIdx(idx)} show-transition ${showTransition ? "show" : ""}`} 
            onClick={handleClick(`${user.id}`)}
            >
            {/* Header row */}
            <div className="card__header">
                <CustomImage
                    state={{ image: image || logo, name: user?.name }}
                    className="thumbnail circle card__avatar"
                    size="52px"
                />
                <div className="card__header-info">
                    <p className="card__name">{user?.name?.toLowerCase()}</p>
                    <p className="card__category">{user?.category?.[0]?.name}</p>
                </div>
                {location?.latitude > -1 && user?.location?.coordinates?.length > 0 && (
                    <span className="card__distance">
                    <i className="fa fa-map-marker" />{" "}
                    {getDistanceFromLatLonInKm(location, user)} km
                    </span>
                )}
            </div>

            {/* <small className="card__fee">{user?.fee ? "Service Charge* " + user?.fee + " INR" : ""}</small> */}
            {/* <small className="card__fee">&nbsp;</small> */}

             {/* Stats panel */}
            <div className="card__stats">
                {isUserAvailable ? (<span className="card__stat">
                    <i className="card__stat-icon card__stat-icon--heart" />
                    🟢 Available 
                    </span>) : (<span className="card__stat">
                    <i className="card__stat-icon card__stat-icon--heart" />
                    🔴 Offline
                    </span>)}

                {ratingByOthersData?.length > 0 && (
                    <span className="card__stat">
                    <i className="fa fa-star card__stat-icon card__stat-icon--star" />
                    {`${ratingByOthersData.length} Rating${ratingByOthersData.length !== 1 ? "s" : ""}`}
                    </span>
                )}
                {user?.commentByOthers?.length > 0 && (
                    <span className="card__stat">
                    <i className="fa fa-comment card__stat-icon" />
                    {`${user.commentByOthers.length} Review${user.commentByOthers.length !== 1 ? "s" : ""}`}
                    </span>
                )}
                {user?.followers?.length > 0 && (
                    <span className="card__stat">
                    <i className="fa fa-heart card__stat-icon card__stat-icon--heart" />
                    {`${user?.followers?.length} Follower${user?.followers?.length !== 1 ? "s" : ""}`}
                    </span>
                )}
            </div>

            {/* <div className="card__title">
                {user?.instalink && <i className="fa fa-instagram"></i>} {user?.fblink && <i className="fa fa-facebook-f mx-1"></i>}
            </div> */}

            {/* Socials — separate row, only if links exist */}
            {(user?.instalink || user?.fblink) && (
            <div className="card__socials">
                {user?.instalink && (
                <span className="card__social-btn card__social-btn--insta">
                    <i className="fa fa-instagram" />
                </span>
                )}
                {user?.fblink && (
                <span className="card__social-btn card__social-btn--fb">
                    <i className="fa fa-facebook-f" />
                </span>
                )}
            </div>
            )}

            {/* Contact CTA */}
            <p className="card__apply">
                <span className="card__link">Contact</span>
                {/* <button className="card__cta">Contact</button> */}
            </p>

              {/* Optional visual indicator when blocked */}
          {/* {blocked && (
            <div className="card_ct__closed-badge">
              <i className="fa fa-clock-o" /> Service Unavailable
            </div>
          )} */}

            </div>)}

            {/* admin */}
            {user && isUserManagementPath && authData?.isAdmin && (<div className={`card_ct card-${getCardColorIdx(idx)} show-transition ${showTransition ? "show" : ""}`}>
                <div className="card__icon d-flex" >
                    <CustomImage state={{ image:image || logo, name: user?.name }} className="thumbnail circle" size={"3rem"} />
                    <div className="p-1 text-truncate">
                        {user?.name?.toLowerCase()} 
                    </div>
                </div>

                {/* <small className="card__fee">{user?.fee ? "Service Charge* " + user?.fee + " INR" : ""}</small> */}
                <small className="card__fee">&nbsp;</small>

                <div className="card__title">{user?.category?.[0]?.name}</div>

                {/* admin */}
                <ul className="card__ratings p-0">
                    <ListItem value={user?.mobile} />
                    {/* <ListItem value={"User status: "+user?.active} /> */}
                    
                    <ListItem value={displayDateTime(user?.subscriptionEndDate ? user?.subscriptionEndDate : user?.updatedAt)} />
                    <ListItem value={user?.pincode} />
                    {/* <ListItem value={"Referral: "+user?.referral} /> */}
                    <ListItem value={"Payment: "+user?.subscribed} cssClassName={user?.subscribed ? 'success' :''} />
                </ul>

                <p className="card__apply d-flex justify-content-between">
                    {user?.category?.[0]?.name !== "user" && <button className="btn btn-sm btn-primary" onClick={handleClick_ApplyPromo(user?.id)}>Active user</button>}
                    {user?.category?.[0]?.name !== "user" && !user?.subscribed && <button className="btn btn-sm btn-primary" onClick={handleClick_Refresh(user?.id)}>Refresh status</button>}
                </p>
                {message && <p className="text-white">{message}</p>}
            </div>)}
        </>
    );
}

export default Card;
